import { PropsWidgetWrapper } from './types'
import { LayoutGallery } from './LayoutGallery'
import { card } from '../../../common/components/CardEditor'
import i18n from 'live/services/i18n'

export default card<PropsWidgetWrapper>({
    title: i18n('E-MAIL BODY CONFIGURATION'),
    className: 'emailBodyConfiguration',
    get: function (report) {
        return {
            page: report?.page,
            layout: report?.mailContent?.layout,
            contentGeneralSpan: report?.mailContent?.generalSpan
        }
    },
    set: function ({ layout, page, contentGeneralSpan }, report) {
        report.mailContent.layout = layout
        report.mailContent.generalSpan = contentGeneralSpan
        report.page = page

        return report
    },
    collapseStartsClosed: true,
    collapseOnHideClosed: true
})(LayoutGallery)
